<template>
  <div class="product-display" v-if="available" @click="emitSelectedVariant()">
    <FeaturedIcon v-if="hasFeaturedInfo" :type="featuredInfoType" />
    <template
      v-if="!anonymousCrossOrigin || hasSVGGroups || isThreekitAvailable"
    >
      <svg
        v-if="
          customPreview || isThreekitAvailable
            ? threekitLayersAreLoaded
            : !anonymousCrossOrigin || hasSVGGroups
        "
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        :viewBox="'0 0 ' + width + ' ' + height"
        :style="'enable-background: new 0 0 ' + width + ' ' + height"
        xml:space="preserve"
      >
        <!-- Threekit 2d -->
        <template v-if="isThreekitAvailable">
          <!-- Custom Preview -->
          <template v-if="customPreview">
            <image
              :width="width"
              :height="height"
              :xlink:href="customPreview"
            ></image>
          </template>
          <template v-else-if="threekitLayersAreLoaded">
            <image
              :width="width"
              :height="height"
              :xlink:href="threekitLayers[0]"
            ></image>
            <image
              :width="width"
              :height="height"
              :xlink:href="threekitLayers[1]"
            ></image>
            <image
              :width="width"
              :height="height"
              :xlink:href="threekitLayers[2]"
            ></image>
            <image
              :width="width"
              :height="height"
              :xlink:href="threekitLayers[3]"
            ></image>
            <image
              v-if="hasDecoration"
              :width="width"
              :height="height"
              :xlink:href="decoration.value"
            ></image>
          </template>
        </template>

        <template v-else>
          <!-- SVG GROUPS -->
          <template v-if="hasSVGGroups && !isPrecoloredDesign">
            <component
              :is="SVGGroupingType"
              v-for="group in 3"
              :key="group"
              :product="product"
              :design="design"
              :groupIndex="group"
              :side="side"
            />
          </template>

          <!-- SHADOW (Can be real shadow, or the fake shadow wich is just a png [Snapsheet product for example]) -->
          <template v-if="hasVariants && !precoloredDesign">
            <component
              :is="shadowType"
              :product="product"
              :gender="gender"
              :side="side"
              :designDimension="designDimension"
              :anonymousCrossOrigin="anonymousCrossOrigin"
            />
          </template>

          <!-- Precolored Design: uses URL for c1, c2, c3 and a common shadow, no base layer -->
          <template v-if="isPrecoloredDesign">
            <PrecoloredDesign
              :precoloredDesign="precoloredDesign"
              :precoloredDesignShadow="precoloredDesignShadow"
              :designDimension="designDimension"
              :isChromagear="isChromagear"
              :anonymousCrossOrigin="anonymousCrossOrigin"
            />
          </template>

          <!-- Team Name and Number -->
          <TextStamp
            v-if="showName"
            :layout="finalLayout"
            :fieldName="'name'"
            :fill="textStampName.fill"
            :outline="textStampName.outline"
            :value="textStampName.value"
            :font="textStampName.font"
          />
          <TextStamp
            v-if="showNumber"
            :layout="finalLayout"
            :fieldName="'number'"
            :fill="textStampNumber.fill"
            :outline="textStampNumber.outline"
            :value="textStampNumber.value"
            :font="textStampNumber.font"
          />

          <!-- Team Name and Number -->
          <TextStamp
            v-if="showName"
            :layout="finalLayout"
            :fieldName="'name'"
            :fill="textStampName.fill"
            :outline="textStampName.outline"
            :value="textStampName.value"
            :font="textStampName.font"
          />
          <TextStamp
            v-if="showNumber"
            :layout="finalLayout"
            :fieldName="'number'"
            :fill="textStampNumber.fill"
            :outline="textStampNumber.outline"
            :value="textStampNumber.value"
            :font="textStampNumber.font"
          />
          <TextStamp
            v-if="showBackName"
            :layout="finalLayout"
            :fieldName="'back_name'"
            :value="textStampName.value"
            :font="textStampName.font"
          />
          <TextStamp
            v-if="showBackNumber"
            :layout="finalLayout"
            :fieldName="'back_number'"
            :value="textStampNumber.value"
            :font="textStampNumber.font"
          />

          <!-- Logo -->
          <image
            v-if="showLogo"
            preserveAspectRatio="xMidYMin"
            class="svg-logo"
            :width="logoProperties ? logoProperties.width : '0%'"
            :x="logoProperties ? logoProperties.x : '0%'"
            :y="logoProperties ? logoProperties.y : '0%'"
            :height="logoProperties ? logoProperties.height : '0%'"
            :xlink:href="productLogo.content || productLogo.url || productLogo"
          ></image>

          <!-- SHADOW (Can be real shadow, or the fake shadow wich is just a png [Snapsheet product for example]) -->
          <template v-if="!hasVariants && !isPrecoloredDesign">
            <component
              :is="shadowType"
              :product="product"
              :gender="gender"
              :side="side"
            />
          </template>
        </template>
      </svg>
      <!-- Loader -->
      <div class="loader-container" v-else-if="!readOnly">
        <Loader />
      </div>
    </template>

    <template v-else>
      <p>EAAAAAAAAA</p>
      <!-- variant as image -->
      <template v-if="hasVariants && !precoloredDesign">
        <component
          :is="shadowType"
          :product="product"
          :gender="gender"
          :side="side"
          :designDimension="designDimension"
          :anonymousCrossOrigin="anonymousCrossOrigin"
        />
      </template>

      <!-- precolored as image -->
      <template v-else>
        <PrecoloredDesign
          :precoloredDesign="precoloredDesign"
          :precoloredDesignShadow="precoloredDesignShadow"
          :designDimension="designDimension"
          :isChromagear="isChromagear"
          :anonymousCrossOrigin="anonymousCrossOrigin"
        />
      </template>

      <!-- precolored as image -->
      <!-- <template v-else> </template> -->
    </template>
  </div>
</template>

<script>
import PrecoloredSVGGroup from "@/components/Projects/Product/ProductDisplay/PrecoloredSVGGroup.vue";
import PrecoloredDesign from "@/components/Projects/Product/ProductDisplay/PrecoloredDesign.vue";
import SVGGroup from "@/components/Projects/Product/ProductDisplay/SVGGroup.vue";
import Shadow from "@/components/Projects/Product/ProductDisplay/Shadow.vue";
import VariantShadow from "@/components/Projects/Product/ProductDisplay/VariantShadow.vue";
import TextStamp from "@/components/Projects/Product/ProductDisplay/TextStamp.vue";
import FeaturedIcon from "@/components/Projects/Product/ProductDisplay/FeaturedIcon.vue";
import Loader from "@/components/Utils/Loader.vue";
import { mapGetters, mapState } from "vuex";

export default {
  name: "ProductDisplay",
  props: {
    product: {
      type: Object,
    },
    layout: {
      type: [Object, Number],
    },
    inheritedDesign: {
      //aka forced design
      type: Array,
    },
    precoloredDesign: {
      type: String,
    },
    customPreview: {
      type: String,
    },
    designDimension: {
      type: Object,
    },
    threekitDesignItem: {
      type: Object,
    },
    precoloredDesignShadow: {
      type: String,
    },
    precoloredType: {
      type: String,
    },
    isChromagear: {
      type: Boolean,
    },
    readOnly: {
      type: Boolean,
    },
    anonymousCrossOrigin: {
      type: Boolean,
    },
    hasFeaturedInfo: {
      type: Boolean,
    },
    featuredInfoType: {
      type: String,
    },
    isThreekitAvailable: {
      type: Boolean,
      default: true,
    },
    threekitLayers: {
      type: Array,
    },
    forcedLocationName: {
      type: String,
    }
  },

  computed: {
    // TODO -> Crear layout computed, retornar primer el overrrideLayout, y sinop el layout delproduct.
    ...mapState(["selectedDesign"]),
    // ...mapState("threekit", ["decorations"]),
    ...mapState("project", [
      "projectLogos",
      "spiritwearLogoId",
      "uniformsLogoId",
    ]),

    ...mapGetters("project", [
      "getProductTextStamp",
      "projectColors",
      "projectTitle",
      "defaultLogo",
      "isSnapsheet",
      "isPlaybook",
      "isShowroom",
    ]),

    ...mapGetters("showroom", ["uniformDecoration", "spiritwearDecoration"]),

    ...mapState("playbook", ["team_name"]),
    ...mapState("project", ["locationDecorations"]),

    finalLayout() {
      const activeLayout =
        this.product.layouts?.find(
          (l) => l.id == this.product.activeLayoutId
        ) ||
        (this.product.layouts && this.product.layouts[0]);

      return (
        //First try to return the native snapsheet layout calculation
        activeLayout?.layout_attributes?.front ||
        //Secondly,the layout that came as a prop
        this.layout
      );
    },

    width() {
      return this.designDimension ? this.designDimension.width : 470;
    },

    height() {
      return this.designDimension ? this.designDimension.height : 588;
    },

    hasColors() {
      return this.projectColors[0] != null;
    },

    available() {
      return true
    },

    design() {
      return this.inheritedDesign ? this.inheritedDesign : this.selectedDesign;
    },

    isPrecoloredProduct() {
      return this.design?.color === "precolored";
    },

    isPrecoloredDesign() {
      return !!this.precoloredDesign;
    },

    hasSVGGroups() {
      return this.design?.svg_data != null || this.isPrecoloredProduct;
    },

    SVGGroupingType() {
      return this.isPrecoloredProduct ? "PrecoloredSVGGroup" : "SVGGroup";
    },

    hasVariants() {
      return this.product?.variant || this.product?.variants?.length > 0;
    },

    shadowType() {
      return this.hasVariants ? "VariantShadow" : "Shadow";
    },

    /* Logo */
    showLogo() {
      if (this.isSnapsheet) {
        //todo, buscar por sideKey (front, back, side)
        return !!this.product.decorations?.front?.logo?.id;
      } else {
        if (this.isShowroom) {
          return !!this.product.layouts?.length; //&& this.product.layouts[0].layout_attributes?.front?.logo
        }
        return (
          !!this.logoProperties &&
          !!this.productLogo &&
          !this.anonymousCrossOrigin
        );
      }
    },

    logoProperties() {
      if (this.isSnapsheet) {
        //Find active layout, or use the first one. (Some products do not have a layout)
        const activeLayout =
          this.product.layouts?.find(
            (l) => l.id == this.product.activeLayoutId
          ) ||
          (this.product.layouts && this.product.layouts[0]);
        return activeLayout ? activeLayout.layout_attributes.front.logo : null;
      } else {
        if (this.isShowroom) {
          return this.product.layouts[0]
            ? this.product.layouts[0].layout_attributes?.front?.logo
            : null;
        }
        return this.layout?.logo;
      }
    },

    productLogo() {
      if (this.isSnapsheet) {
        return this.product.decorations?.front?.logo;
      } else {
        if (this.isShowroom) {
          if (this.product.is_uniform) {
            return this.uniformDecoration;
          }
          return this.spiritwearDecoration;
        }
        return this.product.decorations?.front?.logo || this.defaultLogo;
      }
    },

    spiritwearLogo() {
      const spiritwearLogo = this.projectLogos.filter((logo) => {
        return logo.id == this.spiritwearLogoId;
      })[0];

      return spiritwearLogo;
    },

    uniformsLogo() {
      const uniformsLogo = this.projectLogos.filter((logo) => {
        return logo.id == this.uniformsLogoId;
      })[0];

      return uniformsLogo;
    },

    hasDecoration() {
      return this.decoration != null;
    },

    decoration() {
      /*return this.locationDecorations?.length && this.product.threekit_layout
        ? this.locationDecorations.find((location) => {
          return location.locationName === this.product.threekit_layout
        })
        : null*/
      const productLocationName = this.forcedLocationName || this.product.threekit_layout
      return this.locationDecorations?.find((location) => {
        return location.locationName === productLocationName;
      });
    },

    /* Text Stamps */
    textStampName() {
      const defaultValue = this.isPlaybook
        ? this.team_name?.trim() || "Team Name"
        : "";
      return this.getProductTextStamp(this.product, "name", defaultValue);
    },

    textStampNumber() {
      const defaultValue = this.isPlaybook ? "00" : "";
      return this.getProductTextStamp(this.product, "number", defaultValue);
    },

    showName() {
      return this.isSnapsheet
        ? this.product.decorations?.front?.name?.value && this.finalLayout?.name
        : this.layout?.name && this.textStampName && !this.anonymousCrossOrigin;
    },

    showBackName() {
      return this.isSnapsheet
        ? this.product.decorations?.front?.back_name?.value &&
            this.finalLayout?.back_name
        : this.layout?.back_name && !this.anonymousCrossOrigin;
    },

    showNumber() {
      return this.isSnapsheet
        ? this.product.decorations?.front?.number?.value &&
            this.finalLayout?.number
        : this.layout?.number && !this.anonymousCrossOrigin;
    },

    showBackNumber() {
      return this.isSnapsheet
        ? this.product.decorations?.front?.back_number?.value &&
            this.finalLayout?.back_number
        : this.layout?.back_number && !this.anonymousCrossOrigin;
    },

    threekitLayersAreLoaded() {
      const assetIdOcurrencies = this.threekitLayers
        ?.map((string) => string.split("assetId"))
        ?.flat();
      //The layers config is ready when it has more than 3 AssetIds ocurrencies, otherwise it will show a broken image bc of a 404
      const MINUM_OF_ASSET_IDS = 3;
      return assetIdOcurrencies?.length > MINUM_OF_ASSET_IDS ? true : false;
    },
  },

  methods: {
    emitSelectedVariant() {
      //todo -> en este caso es stock spiritiwear, y emito el variant name,
      // pero como hariamos con stocks sublimables?(es decir, de IP) si usan la misma tecnica de 'falsa sombra' capaz nos sirva esto mimso, mandar el variant name
      this.$emit("selectVariant", this.product.variant);
    },
  },

  mounted() {
    if (this.isPlaybook) {
      this.gender = this.product?.gender;
    } else {
      if (this.isShowroom) {
        this.gender = this.product?.gender?.toLowerCase();
      }
    }
  },

  data() {
    return {
      side: "front",
      gender: "",
    };
  },

  watch: {
    threekitLayers() {
      //console.log("threekitLayers", this.threekitLayers);
    },
  },

  components: {
    PrecoloredSVGGroup,
    PrecoloredDesign,
    SVGGroup,
    Loader,
    Shadow,
    VariantShadow,
    TextStamp,
    FeaturedIcon,
  },
};
</script>

<style lang="scss" scoped>
.product-display {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  //height: 100%;
  height: fit-content;
  max-height: 100%;
  svg {
    height: 100%;
  }
}

.page-designs .product-display {
  height: 25em;
}
</style>
